module.exports = __webpack_public_path__ + "static/media/running.b7f7604f.svg";